import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import { type AirActionTrackingLocation } from '../types';
import META from './useTrackDuplicatedAsset.meta';

export type TrackDuplicatedAssetParams = {
  assetId: string;
  sourceAssetId: string;
  location: AirActionTrackingLocation;
  boardId?: string;
  isFile: boolean;
};

export const useTrackDuplicatedAsset = () => {
  const { track } = useAnalyticsUtilities();

  const trackDuplicatedAsset = useCallback(
    (params: TrackDuplicatedAssetParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackDuplicatedAsset };
};
